// src/pages/Fornecedores.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import api from '../services/api';
import FornecedorModal from '../components/FornecedorModal';
import { FaHome } from 'react-icons/fa';

const instancia = process.env.REACT_APP_INSTANCIA;

const Container = styled.div`
  padding: 40px;
  max-width: 1000px;
  margin: 0 auto;
`;

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: bold;
  color: #4b0082;
`;

const Button = styled.button`
  background-color: ${(props) => props.danger ? '#d9534f' : props.secondary ? '#f0ad4e' : '#5cb85c'};
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 14px;
  cursor: pointer;
  margin-left: ${(props) => props.marginLeft || '0'};

  &:hover {
    opacity: 0.9;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  overflow: hidden;
`;

const TableHeader = styled.th`
  background-color: #6a0dad;
  color: white;
  padding: 14px;
  font-weight: 600;
  text-align: left;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f9f9f9;
  }

  &:hover {
    background-color: #f1f1f1;
  }
`;

const TableCell = styled.td`
  padding: 12px 14px;
  color: #333;
  font-size: 14px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;


const Fornecedores = () => {
    const [fornecedores, setFornecedores] = useState([]);
    const [modalAberto, setModalAberto] = useState(false);
    const [fornecedorEditando, setFornecedorEditando] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await api.get(`/fornecedores/${instancia}/todos`);
            setFornecedores(response.data);
        } catch (error) {
            toast.error('Erro ao carregar fornecedores');
        }
    };

    const handleIncluir = () => {
        setFornecedorEditando(null);
        setModalAberto(true);
    };

    const handleEditar = (fornecedor) => {
        setFornecedorEditando(fornecedor);
        setModalAberto(true);
    };

    const handleSalvar = async (dados) => {
        try {
            if (fornecedorEditando) {
                console.log(fornecedorEditando);
                console.log(dados);
                await api.put(`/fornecedores/${fornecedorEditando.COD_FORNECEDOR}`, dados);
                toast.success('Fornecedor atualizado com sucesso');
            } else {
                await api.post('/fornecedores', dados);
                toast.success('Fornecedor criado com sucesso');
            }
            fetchData();
            setModalAberto(false);
        } catch (error) {
            toast.error('Erro ao salvar fornecedor');
        }
    };


    const handleExcluir = async (id) => {
        if (!window.confirm('Tem certeza que deseja excluir este fornecedor?')) return;
        try {
            await api.delete(`/fornecedores/${id}`);
            toast.success('Fornecedor excluído com sucesso');
            fetchData();
        } catch (error) {
            toast.error('Erro ao excluir fornecedor');
        }
    };

    return (
        <Container>
            {modalAberto && (
                <FornecedorModal
                    onClose={() => setModalAberto(false)}
                    onSave={handleSalvar}
                    initialData={fornecedorEditando}
                />
            )}

            <TitleRow>
                <Button
                    variant="primary"
                    size="small"
                    onClick={() => {
                        setFornecedorEditando(null);
                        setModalAberto(false);
                        navigate('/home');
                    }}
                >
                    <FaHome style={{ marginRight: '8px' }} /> {/* Ícone à esquerda */}
                    Home
                </Button>
                <Title>Lista de Fornecedores</Title>
                <Button onClick={handleIncluir}>+ Incluir Fornecedor</Button>
            </TitleRow>
            <StyledTable>
                <thead>
                    <tr>
                        <TableHeader>Nome</TableHeader>
                        <TableHeader>Razão Social</TableHeader>
                        <TableHeader>CNPJ</TableHeader>
                        <TableHeader>Email</TableHeader>
                        <TableHeader>Telefone</TableHeader>
                        <TableHeader>Ações</TableHeader>
                    </tr>
                </thead>
                <tbody>
                    {fornecedores.map((f) => (
                        <TableRow key={f.COD_FORNECEDOR}>
                            <TableCell>{f.NOME}</TableCell>
                            <TableCell>{f.RAZAO_SOCIAL}</TableCell>
                            <TableCell>{f.CNPJ_CPF}</TableCell>
                            <TableCell>{f.EMAIL}</TableCell>
                            <TableCell>{f.FONE}</TableCell>
                            <TableCell>
                                <ButtonGroup>
                                    <Button secondary onClick={() => handleEditar(f)}>Editar</Button>
                                    <Button danger onClick={() => handleExcluir(f.COD_FORNECEDOR)}>Excluir</Button>
                                </ButtonGroup>
                            </TableCell>

                        </TableRow>
                    ))}
                </tbody>
            </StyledTable>
        </Container>
    );
};

export default Fornecedores;
